import { QueryObject, FetchDataForReporting } from './ReportDataFetch';
import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';

export interface Filter {
  label: string;
  type?: 'date' | 'string' | 'date-int';
  data?: QueryObject;
  onChange: (s: any) => void;
}

export const FilterComponent: FunctionComponent<Filter> = filter => {
  const [labels, setLabels] = useState<any[]>([]);
  const [values, setValues] = useState<any[]>([]);
  const onValueChange = (s: any) => filter.onChange(s);
  const onDateChange = (date: Dayjs | null) => {
    if (date) {
      if (filter.type === 'date-int')
        onValueChange(date.startOf('day').unix() * 1000);
      else onValueChange(date.startOf('day').format('YYYY-MM-DD'));
    } else onValueChange(null);
  };

  let filterComponent = null;
  if (filter.type) {
    switch (filter.type) {
      case 'date-int':
      case 'date':
        filterComponent = (
          <DatePicker picker="date" onChange={onDateChange}></DatePicker>
        );
        break;
      case 'string':
        filterComponent = TextFilter(onValueChange);
        break;
    }
  } else if (filter.data) {
    filterComponent = (
      <SelectFilter
        {...{
          label: filter.label,
          labels: labels,
          values: values,
          onValueChange: onValueChange
        }}
      />
    );
  }

  useEffect(() => {
    if (filter.data) {
      FetchDataForReporting(filter.data).then(response => {
        setLabels(response.labels);
        setValues(response.values);
      });
    }
  }, [filter.data]);

  return (
    <div className="reportFilter">
      <label> {filter.label} </label> <br></br>
      {filterComponent}
    </div>
  );
};

const TextFilter = (onChange: (s: string) => void) => {
  const onLocalChange = (event: React.FocusEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return <input type="text" onBlur={onLocalChange} />;
};

interface SelectFilterProps {
  label: string;
  labels: string[];
  values: string[];
  onValueChange: (s: string) => void;
}

const SelectFilter: FunctionComponent<SelectFilterProps> = props => {
  const { label, labels, values, onValueChange } = props;
  const onChange = (event: ChangeEvent) => onValueChange(event.target.value);

  return (
    <select onChange={onChange}>
      <option value="null"> {label} </option>
      {labels.map((l, i) => (
        <option key={i} value={values[i]}>
          {' '}
          {l}{' '}
        </option>
      ))}
    </select>
  );
};
